import { render } from "./_vCardIndirizzo.vue?vue&type=template&id=307359ef"
import script from "./_vCardIndirizzo.vue?vue&type=script&lang=js"
export * from "./_vCardIndirizzo.vue?vue&type=script&lang=js"

import exportComponent from "/Users/andreavadacchino/Desktop/pADV/untitled/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__